// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateSetting_cancelButton__7aNvU","deleteButton":"UpdateSetting_deleteButton__2divr","rowContainer":"UpdateSetting_rowContainer__1UEZF"};